import { useEffect, useRef, useState } from 'react';

const CustomScrollbar = () => {
  const [isScrollThumbEnabled,setIsScrollThumbEnabled]=useState(null);

  const elem1Ref = useRef(null); // Ref for the first scrolling div
  const elem1ContentRef = useRef(null); // Ref for the scrolling content
  const elem2Ref = useRef(null); // Ref for the second element to synchronize with

  useEffect(() => {
    let ignoreEvent = false;

    const handleScrollElem1 = () => {
        if (ignoreEvent) {
            ignoreEvent = false;
            return;
        }

        ignoreEvent = true;

        if (isScrollThumbEnabled === 'enabled') {
            elem2Ref.current.scrollTop = elem1Ref.current.scrollTop;
        } else {
            document.documentElement.scrollTop = elem1Ref.current.scrollTop;
        }
    };

    const handleScrollElem2 = () => {
        if (ignoreEvent) {
            ignoreEvent = false;
            return;
        }
        ignoreEvent = true;

        const elem2 = isScrollThumbEnabled === 'enabled' ? elem2Ref.current : document.documentElement;
        const elem1Content = elem1ContentRef.current;

        elem1Content.style.height = `${elem2.scrollHeight}px`;
        elem1Ref.current.scrollTop = elem2.scrollTop;
    };

    const elem1 = elem1Ref.current;
    const elem2 = isScrollThumbEnabled === 'enabled' ? elem2Ref.current : document.documentElement;

    if (elem1) {
        elem1.addEventListener('scroll', handleScrollElem1);
    }

    if (isScrollThumbEnabled === 'enabled') {
        elem2.addEventListener('scroll', handleScrollElem2);
    } else {
        window.addEventListener('scroll', handleScrollElem2);
    }

    return () => {
        if (elem1) {
            elem1.removeEventListener('scroll', handleScrollElem1);
        }
        if (isScrollThumbEnabled === 'enabled') {
            elem2.removeEventListener('scroll', handleScrollElem2);
        } else {
            window.removeEventListener('scroll', handleScrollElem2);
        }
    };
  }, [isScrollThumbEnabled]);

  useEffect(() => {
    const alimScrollIndicator = document.getElementById('alim-scroll-indicator');
    const isScrollThumbEnabled = alimScrollIndicator ? alimScrollIndicator.getAttribute('data-scroll-thumb') : 'disabled';

    setIsScrollThumbEnabled(isScrollThumbEnabled);

    // Initialize elem2Ref with the alim-scroll-indicator element
    const alimCustomContentContainer = document.getElementById('alim-scroll-content');
    
    if (alimCustomContentContainer) {
      // Assign it to elem2Ref.current
      elem2Ref.current = alimCustomContentContainer;
    }
  }, []);

  return (
    <div
        id="scrolling-div"
        ref={elem1Ref}
        className="hidden lg:block fixed top-[56px] md:top-[68px] lg:top-[80px] lg:right-3 h-[calc(100%-56px)] flex md:h-[calc(100%-68px)] lg:h-[calc(100%-80px)] w-5 overflow-y-scroll z-[10]"
    >
        <div
            id="scroller-content"
            ref={elem1ContentRef}
            className="h-0 w-0"
        />
    </div>
  );
};

export default CustomScrollbar;